import { IconProps } from '@common/types/common';

const Computer = ({ stroke = '#005FBE' }: IconProps) => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.99967" y="6.66667" width="30" height="21.6667" rx="1.66667" stroke={stroke} strokeWidth="3.33333" />
        <path
            d="M25.833 28.3337V31.6667C25.833 32.5871 25.0873 33.3336 24.167 33.3337H15.833C14.9127 33.3336 14.167 32.5871 14.167 31.6667V28.3337H25.833Z"
            stroke={stroke}
            strokeWidth="3.33333"
        />
    </svg>
);

export { Computer };
